import { ReactNode } from 'react'

/**
 * A status pill: a classification-coloured dot followed by its label.
 *
 * Separate from Badge because the dot is the point — the colour has to survive a
 * glance down a table column, and Badge has no slot for a leading mark. Its tones
 * are also the ink scale, whereas status here means the moderation palette.
 */
export type StatusTone = 'safe' | 'suspect'

const TONES: Record<StatusTone, { pill: string; dot: string }> = {
    safe: { pill: 'bg-safe/10 text-safe', dot: 'bg-safe' },
    suspect: { pill: 'bg-suspect/10 text-suspect', dot: 'bg-suspect' }
}

export default function StatusPill({
    tone,
    children
}: {
    tone: StatusTone
    children: ReactNode
}) {
    const { pill, dot } = TONES[tone]
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${pill}`}
        >
            <span className={`h-1.5 w-1.5 rounded-full ${dot}`} aria-hidden="true" />
            {children}
        </span>
    )
}
